import { DocumentUploadType } from '@webtronic-labs/contracts-hip-hip';

export interface IUserUploadedDocument {
  url: string;
  name: string;
  type: DocumentUploadType;
}
